import { components } from '@doltech/pageManagement/dto';
import { SkillEnum } from '@doltech/utils/lib/constants';
import * as React from 'react';
import styled from 'styled-components';

import { useViewTestSubjectStore } from './model/view-test-subject.hook';
import dynamic from 'next/dynamic';
import { SubjectListeningContentPdfProps } from './SubjectListeningContentPdf';

const CONTENT_PDF_WIDTH = 848;

const Main = styled.div`
  width: ${CONTENT_PDF_WIDTH}px;
`;

const SubjectListeningContentPdf = dynamic<SubjectListeningContentPdfProps>(
  () => import('./SubjectListeningContentPdf').then((mod) => mod.SubjectListeningContentPdf),
  {
    loading: () => <div>Loading...</div>,
  }
);

const SubjectReadingContentPdf = dynamic(
  () => import('./SubjectReadingContentPdf').then((mod) => mod.SubjectReadingContentPdf as any),
  {
    loading: () => <div>Loading...</div>,
  }
);

interface ViewTestSubjectPdfLayoutPros {
  seoData: components['schemas']['PageResponseDTOObject'];
}

export const ViewTestSubjectPdfLayout = (props: ViewTestSubjectPdfLayoutPros) => {
  const store = useViewTestSubjectStore();
  if (!store.initialed) return null;

  return (
    <Main>
      {store.skill === SkillEnum.LISTENING ? (
        <SubjectListeningContentPdf {...props} />
      ) : (
        <SubjectReadingContentPdf />
      )}
    </Main>
  );
};
